import { createSelectorCreator, weakMapMemoize } from "reselect";
import { weakMapMemoizeCustom } from "./weakMapMemoizeCustom";

export const createStateAccessSelector = createSelectorCreator({
  memoize: weakMapMemoizeCustom,
  argsMemoize: weakMapMemoize
});
